<script>

import WithdrawalRequestsTable from "@/components/companies/WithdrawalRequestsTable.vue";
import WithdrawalSettlementsTable from "@/components/companies/WithdrawalSettlementsTable.vue";

export default {
    components: {WithdrawalSettlementsTable, WithdrawalRequestsTable},
    data() {
        return {
            loading: {
                company: true,
                settlement: true,
            },
            downloading: {
                requests: false,
                settlements: false,
            },
            company: {},
            settlements: [],
            settlementsMeta: {
                current_page: 1,
                total: 0,
                per_page: 0,
            },
            showSettleModal: false,
            controller: null,
            company_id: this.$route.params.id ? this.$route.params.id : this.$auth.user.company_id
        }
    },
    methods: {
        loadData() {
            this.$refs.withdrawalRequestsTable.loadData();
            this.$refs.withdrawalSettlementsTable.loadData();
            this.loadCompany();
        },
        loadCompany() {
            this.controller = new AbortController();
            this.loading.company = true;
            axios.get('/companies/' + this.company_id, {
                signal: this.controller.signal,
            }).then(response => {
                this.company = response.data.data;
            }).catch(error => {
            }).finally(() => {
                this.loading.company = false;
            })
        },
        openSettleModal() {
            this.showSettleModal = true;
        },
        closeSettleModal(data) {
            if (data.settled) {
                this.loadData();
            }
            this.showSettleModal = false;
        },
        downloadWithdrawalRequests() {
            this.downloading.requests = true;
            let params = {
                status: 'pending',
                xlsx: 1
            }
            axios({
                url: '/companies/' + this.company_id + '/withdrawal-requests',
                method: 'GET',
                responseType: 'blob',
                params
            }).then((response) => {
                saveAs(response.data, 'withdrawal-requests.xlsx');
            }).finally(() => {
                this.downloading.requests = false;
            });
        },
        downloadWithdrawalSettlements() {
            this.downloading.settlements = true;
            let params = {
                xlsx: 1
            }
            axios({
                url: '/companies/' + this.company_id + '/withdrawal-settlements',
                method: 'GET',
                responseType: 'blob',
                params
            }).then((response) => {
                saveAs(response.data, 'withdrawal-settlements.xlsx');
            }).finally(() => {
                this.downloading.settlements = false;
            });
        }
    },
    mounted() {
        this.loadCompany();
    },
    beforeUnmount() {
        this.controller && this.controller.abort();
    }
}

</script>
<template>
    <section>
        <settle-withdrawals-modal v-if="showSettleModal" :company="company" @close="closeSettleModal"/>

        <loader :loading="loading.company"></loader>

        <section class="block" v-if="!loading.company">
            <div class="block title is-4" v-if="$auth.isAdmin()">
                {{ company.name }}
            </div>

            <div class="info-cards-container mb-6 mt-6 is-flex is-justify-content-center is-align-items-stretch">
                <div class="card info-card has-text-centered is-align-content-center">
                    <div class="card-content">
                        <div class="title is-4 mb-4">{{ company.withdrawals_token_amount ? company.withdrawals_token_amount : '0 zł' }} </div>
                        <div class="subtitle is-6">{{ $t('companies.labels.total_requests_value') }}</div>
                    </div>
                </div>
                <div class="info-card has-text-centered is-align-content-center" v-if="$auth.isAdmin()">
                    <button class="button is-link" @click="openSettleModal" :disabled="!company.withdrawals_token_amount">
                        {{ $t('companies.actions.settle') }}
                    </button>
                </div>
            </div>
        </section>

        <div class="section-title is-size-5 is-uppercase">
            {{ $t('companies.labels.unsettles_requests') }}
        </div>

        <div class="mb-4 mt-4">
            <b-button v-if="$auth.isAdmin()" :loading="downloading.requests" type="is-link" icon-left="download" @click="downloadWithdrawalRequests">
                .xlsx
            </b-button>
        </div>

        <withdrawal-requests-table :company-id="company_id" :pending="true" ref="withdrawalRequestsTable"/>


        <div class="section-title is-size-5 is-uppercase">
            {{ $t('companies.labels.settlements') }}
        </div>

        <div class="mb-4 mt-4">
            <b-button v-if="$auth.isAdmin()" :loading="downloading.settlements" type="is-link" icon-left="download" @click="downloadWithdrawalSettlements">
                .xlsx
            </b-button>
        </div>

       <withdrawal-settlements-table :company-id="company_id" ref="withdrawalSettlementsTable"/>

    </section>
</template>
